import { h } from "./../../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
var Item = function (_props) { return null; };
export default function (ComposedComponent) {
    var _a;
    return _a = (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.select = function (value, itemHeight, scrollTo) {
                    var children = React.Children.toArray(_this.props.children);
                    for (var i = 0, len = children.length; i < len; i++) {
                        if (children[i].props.value === value) {
                            _this.selectByIndex(i, itemHeight, scrollTo);
                            return;
                        }
                    }
                    _this.selectByIndex(0, itemHeight, scrollTo);
                };
                _this.doScrollingComplete = function (top, itemHeight, fireValueChange) {
                    var children = React.Children.toArray(_this.props.children);
                    var index = _this.computeChildIndex(top, itemHeight, children.length);
                    var child = children[index];
                    if (child) {
                        fireValueChange(child.props.value);
                    }
                    else if (console.warn) {
                        console.warn('child not found', children, index);
                    }
                };
                return _this;
            }
            class_1.prototype.selectByIndex = function (index, itemHeight, zscrollTo) {
                if (index < 0 || index >= React.Children.count(this.props.children) || !itemHeight) {
                    return;
                }
                zscrollTo(index * itemHeight);
            };
            class_1.prototype.computeChildIndex = function (top, itemHeight, childrenLength) {
                var index = Math.round(top / itemHeight);
                return Math.min(index, childrenLength - 1);
            };
            class_1.prototype.render = function () {
                return (h(ComposedComponent, __assign({}, this.props, { doScrollingComplete: this.doScrollingComplete, computeChildIndex: this.computeChildIndex, select: this.select })));
            };
            return class_1;
        }(React.Component)),
        _a.Item = Item,
        _a;
}
